// extracted by css-extract-rspack-plugin
export default {"root":"Footer-module__root___AcXiz","rowsCount":"Footer-module__rowsCount___tzsXx"};